import { render, staticRenderFns } from "./ItWeekly.vue?vue&type=template&id=c3ad283a&scoped=true&"
import script from "./ItWeekly.vue?vue&type=script&lang=js&"
export * from "./ItWeekly.vue?vue&type=script&lang=js&"
import style0 from "./ItWeekly.vue?vue&type=style&index=0&id=c3ad283a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ad283a",
  null
  
)

export default component.exports